import { useEffect, useState } from "react";

import { ResultCardItem } from "@evr/components/ResultSidebar/ResultCard/ResultCardComponents";
import { useAppDispatch } from "@evr/hooks/reduxHooks";
import { toggleShowingJourney } from "@evr/store/slices/result";
import { JourneyColor, ScheduledJourney } from "@evr/types";
import { RowContainer } from "@evr/ui/FlexBox";
import { Icon } from "@evr/ui/Icon";
import { IconButton } from "@evr/ui/IconButton";
import { Typography } from "@evr/ui/Typography";

interface InProgressJourneyResultItemsProps {
  scheduledJourney: ScheduledJourney;
  onOpenDetails: () => void;
  journeyColor: JourneyColor;
  maximize?: boolean;
}

const InProgressJourneyResultItems = ({
  scheduledJourney,
  onOpenDetails,
  journeyColor,
  maximize,
}: InProgressJourneyResultItemsProps) => {
  const formatTime = (value: number): string => {
    if (value == null) {
      return "-";
    }
    const hours = Math.floor(Math.abs(value) / 60);
    const minutes = Math.abs(value) % 60;
    const sign = value < 0 ? "-" : "+";

    if (hours >= 1) {
      const formattedHours = hours + minutes / 60;
      return `${sign}${formattedHours.toFixed(1)}h`;
    } else {
      return `${sign}${minutes}m`;
    }
  };

  const getStateOfChargeDeltaString = (value: number): string => {
    if (value == null) {
      return "-";
    } else if (value > 0) {
      return `+${value}%`;
    } else {
      return `${value}%`;
    }
  };

  return (
    <RowContainer
      background={journeyColor.main}
      color={journeyColor.contrast}
      padding="0.5rem 0"
      height="70px"
      width="100%"
      justify="space-evenly"
    >
      {maximize && (
        <>
          <ResultCardItem title="completed / remaining jobs">
            <Icon className="fas fa-cube" />
            <Typography size={1}>
              {scheduledJourney.jobsCompleted} / {scheduledJourney.jobsRemaining}
            </Typography>
          </ResultCardItem>
          <ResultCardItem border title="ahead / behind expected time">
            <Icon className="fas fa-stopwatch" />
            <Typography size={1}>{formatTime(scheduledJourney.etaDeviationDelta)}</Typography>
          </ResultCardItem>
          <ResultCardItem borderRight title="more / less expected battery">
            <Icon className="fas fa-battery-three-quarters" />
            <Typography size={1}>{getStateOfChargeDeltaString(scheduledJourney.stateOfChargeDelta)}</Typography>
          </ResultCardItem>
          <ResultCardItem hoverEffect>
            <IconButton icon="caret-down" WH="25px" title="Click to view Journey details" onClick={onOpenDetails} />
          </ResultCardItem>
        </>
      )}
    </RowContainer>
  );
};

export default InProgressJourneyResultItems;
